<template>
  <div class="main">
    <LiveClassSlider />
    <section>
      <div class="container">
        <div class="row">
          <div v-if="$vuetify.display.mdAndDown" class="col-md-12 col-12">
            <v-btn
              size="large"
              append-icon="$mdiChevronDown"
              color="primary"
              variant="tonal"
              class="rounded-lg my-0 d-flex justify-content-between font-weight-bold"
              style="letter-spacing: 0"
              width="100%"
              @click="openMegaMenu">
              دوره
            </v-btn>
          </div>
          <div class="col-lg-6 col-md-12 ">
            <img class="img-fluid sec1-img" width="500" height="384" alt="classino intro" src="/lcp.png">
          </div>
          <div class="col-lg-6 col-md-12 intro-section">

            <h1 class="cl-heading head-title">کلاسینو اولین و قوی‌ترین <br>آموزشگاه آنلاین ابتدایی تا کنکور</h1>
            <img class="img-fluid sec1-img-mobile" width="500" height="384" alt="classino intro" src="/lcp.png">
            <p class="cl-paragraph">کلاسینو آموزشگاه آنلاینی هست که مجازی سرکلاس حاضر میشی، به صورت زنده
              با استاد حرف میزنی، تکالیف
              و آزمون ها جدی پیگیری میشن و از هر جای دنیا میتونی به کلاسینو دسترسی پیدا کنی.</p>
          </div>
        </div>
      </div>
    </section>


    <section class="cl-bg-white">
      <div class="container-fluid container-lg ">
        <h2 class="cl-heading text-center  mb-5">دوره‌های ۱۴۰۳-۱۴۰۴ کلاسینو</h2>
        <DesktopMainCourses1403 />
      </div>
    </section>

    <AnnouncementsSlider />

    <section class="">
      <div class="container">
        <h2 class="cl-heading text-center">مجموعه ای از بهترین اساتید کنکور ایران</h2>
        <v-row>
          <v-col cols="12" class="prof-slider-box px-0">
            <prof-slider></prof-slider>
          </v-col>
          <v-col cols="12" class="mt-md-4 mt-3 mb-4 mb-md-0 text-center">
            <router-link :to="{name:'professors'}" class="btn cl-btn cl-btn-orange w-mobile-100"> مشاهده کادر <span
              style="font-weight: 900;margin: 0 4px"> اساتید </span> کلاسینو
            </router-link>
            <!--            <a href="" class="btn cl-btn cl-btn-orange ">مشاهده کادر اساتید کلاسینو</a>-->
          </v-col>
        </v-row>
      </div>
    </section>

    <TopStudents />


    <section class="cl-bg-white">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2 class="cl-heading text-center">کلاسینو در رسانه</h2>
          </div>
        </div>
        <div class="row">
          <ClAdvertiseSlider />
        </div>
      </div>
    </section>

  </div>

</template>

<script>

import LiveClassSlider from '@/components/slider/LiveClassSlider.vue'
import DesktopMainCourses1403 from '@/components/DesktopMainCourses1403.vue'
import AnnouncementsSlider from '@/components/slider/AnnouncementsSlider.vue'
import ProfSlider from '@/components/slider/ProfSlider.vue'
import TopStudents from '@/components/home/TopStudents.vue'
import ClAdvertiseSlider from '@/components/home/ClAdvertiseSlider.vue'
import mixinMeta from '@/mixins/mixin.meta'

export default {
  name: 'HomeView',
  mixins: [mixinMeta],
  components: {
    ClAdvertiseSlider,
    TopStudents,
    ProfSlider,
    AnnouncementsSlider,
    DesktopMainCourses1403,
    LiveClassSlider

    // DesktopMainCourses1403,
    // AnnouncementsSlider: lazyLoadComponent({
    //   componentFactory: () => import('@/components/slider/AnnouncementsSlider'),
    //   loading: SkeletonBox,
    // }),
    // ProfSlider: lazyLoadComponent({
    //   componentFactory: () => import('@/components/slider/ProfSlider'),
    //   loading: SkeletonBox,
    // }),
    // TopStudents: lazyLoadComponent({
    //   componentFactory: () => import('../components/home/TopStudents'),
    //   loading: SkeletonBox,
    // }),

  },
  data() {
    return {
      id: 1,
      isActive: 'time',
      loading: false
    }
  },
  computed: {
    isDesktop() {
      return window.screen.width > 768
    }
  },
  mounted() {
    // this.loading = this.$vs.loading({
    //   text: 'اساتید کلاسینو',
    //   type: 'circles',
    //   target: this.$refs.profSliderContainer,
    //   scale: 1.2,
    // })

    // setInterval(this.countdown, 1000);
  },
  methods: {
    openMegaMenu() {
      this.$store.dispatch('megaMenu/openMenu')
    }
  },
  head() {
    const title = 'کلاسینو - اولین و بزرگترین آموزشگاه و کلاس آنلاین کنکور و پایه'
    const description = 'کلاسینو آموزشگاه کنکور آنلاینی هست که مجازی سرکلاس حاضر میشی، به صورت زنده با استاد حرف میزنی، تکالیف و آزمون ها جدی پیگیری میشن و از هر جای دنیا میتونی به کلاسینو دسترسی پیدا کنی'
    return this.createMeta({
      title,
      description
    })
  }

}
</script>
<style lang="scss">

.main-page-btns-group {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  button {
    @include media-breakpoint-down(md) {
      width: 100%;
      &:not(:last-child) {
        margin-bottom: 1rem;
      }
    }

    &:hover {
      transform: translateY(-3px)
    }

    width: 250px;
  }
}

.prof-slider-box {
  min-height: 250px;

  .vs-loading {
    z-index: 997;
  }
}

a.h_iframe-aparat_embed_frame {
  position: relative;
}

.h_iframe-aparat_embed_frame .ratio {
  display: block;
  width: 100%;
  height: auto;
}

.h_iframe-aparat_embed_frame iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
